document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM loaded");

    // Fetch the JSON file
    fetch(chefDataUrl)
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then((data) => {
            console.log("Chef data:", data);
            console.log('Chef name', chefName);

            // Do something with the JSON data
            // Filter the chef object from the data
            var selectedChef = data.filter((chef) => chef.name === chefName);

            if (selectedChef.length > 0) {
                selectedChef = selectedChef[0];
            }

            const chefDesc = document.getElementById('chef-desc');
            chefDesc.innerHTML = selectedChef.description;
        })
        .catch((error) => {
            console.error("Error loading JSON:", error);
        });
});
